import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { globalStore } from '../../global.store';
import { authorizationStore } from '../../modules/authorization/authorization.store';
import { Approved } from '../modalcontainer/bodyContent/approved';
import Modalcontainer from '../modalcontainer';

const GuestPopup = observer(() => {
  const navigate = useNavigate();
  const { setGuestPopupState, setRefreshPage } = globalStore;
  return (
    <Modalcontainer
      backBtn={false}
      closePopup={() => {
        setGuestPopupState(false);
        setRefreshPage(false);
        authorizationStore.setRedirectUrl('');
      }}
    >
      <Approved
        accept={{
          text: 'Sign Up',
          color: 'primary',
        }}
        decline={{
          text: 'Sign In',
          color: 'roundedSecondary',
        }}
        declineAction={() => {
          navigate('?auth=login');
          setGuestPopupState(false);
        }}
        acceptAction={() => {
          navigate('?auth=registration');
          setGuestPopupState(false);
        }}
        headerText={{
          title: 'Sign In or Sign Up to continue!',
        }}
      />
    </Modalcontainer>
  );
});

export default GuestPopup;
